import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DeleteIcon, ListFilter, Package2, PanelLeft, Search } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "../../component/ui/tooltip";
import { Button } from "../../component/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu"
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator, useBreadCrumb } from "../../component/ui/breadcrumb";
import { dashboardIcon, dashboardIconBlue, investorIcon, investorIconBlue, reportIcon, reportIconBlue, viewIcon } from "../../assets/icons";
import DataTable2 from "../../component/table/dataTable2";
import { InvestorInfo } from "./InvestorInfo";
import { Input } from "../../component/ui/input";
import { useDispatch, useSelector } from "react-redux";
import Datatable3 from "../../component/table/datatable3";
import { getInvestorInfo } from "../../utils/util";
import { setInvestorInfo } from "../../context/actions/investorInfoAction";
import { loaderSet } from "../../context/actions/loaderAction";
import Profile from "../../component/profile";
import { nullUserDetails } from "../../context/actions/userAction";
import { alertDanger } from "../../context/actions/toastAction";


// import { Dashboard } from "./Dashboard";

export function Layout() {
  const dispatch = useDispatch()
  const [collapsed, setCollapsed] = useState(true); // Sidebar state
  // const [selectedTab, setSelectedTab] = useState("Dashboard"); // Track the selected tab
  const location = useLocation()
  const { selectedTab, setSelectedTab, selectedSubTab, setSelectedSubTab } = useBreadCrumb()
  const userInfo = useSelector(state => state.user)
  const [investorInfoComponent, setInvestorInfoComponent] = useState(false)
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState("")
  const searchInputId = "distributor-investor-search";
  const handleToggle = () => {
    setCollapsed(!collapsed); // Toggle collapsed state
  };

  const handleTabClick = (tabName) => {
    setSelectedTab(tabName); // Set the selected tab on click
  };

  useEffect(() => {
    setSelectedTab("Investor")
  }, [])


  const buttonOptions = [
    // {
    //   icon: download,
    //   alt: 'Send Icon',
    //   text: <span className="text-base font-semibold">Download Certificate</span>,
    //   iconHeight: 4,
    //   iconWidth: 18,
    //   iconColor: 'text-[#FFFFFF]',
    //   name: 'Download'
    // },
    {
      icon: viewIcon,
      alt: '',
      text: <span className="text-base font-semibold">View</span>,
      iconHeight: 4,
      iconWidth: 4,
      iconColor: 'text-[#FFFFFF]',
      name: 'Delete'
    }
  ];

  const columns = [
    { id: 'name', header: ' Name' },
    { id: 'user_email', header: 'Email' },
    { id: 'mobile_number', header: 'Phone No' },
    // { id: 'scheme', header: 'Scheme' },
    // { id: 'class', header: 'Class' },
  ];

  const handleInvestorInfoId = async (data) => {
    console.log("handleInvestorInfoId", data)
    if (data) {
      // const payload={
      //   user_email: data.user_email
      //   ,
      //   user_type: data.user_type,
      //   user_id: data.user_id
      // }
      try {
        // const response=await getInvestorInfo(payload)
        console.log("response for handleInvestorInfoId", data)
        if (data) {
          dispatch(setInvestorInfo(data))
          // dispatch(setInvestorInfo(response))
          setInvestorInfoId(data.user_id)
          setInvestorInfoComponent(true)
        }
      } catch (error) {
        console.log("Error in handleInvestorInfoId function ", error)
      }
    }
    else {
      dispatch(alertDanger("Internal Server Error"))
    }
  }

  const [investorInfoId, setInvestorInfoId] = useState(null)

  // const handleInvestorInfoId=(id)=>{
  //   setInvestorInfoId(id)
  // }

  const backToDistributorLayout = () => {
    setInvestorInfoId(null)
  }

  const navigation = [
    { name: "Investor", href: "#", icon: investorIcon, icon2: investorIconBlue, current: selectedTab === "Investor" },
    // { name: "Reports", href: "#", icon: reportIcon, icon2: reportIconBlue, current: selectedTab === "Reports" },
  ];
  const distributorInfo = useSelector(state => state.distributorInfo)
  const investorDetailsForTable = distributorInfo && distributorInfo.investors


  const handleLogout = () => {
    dispatch(loaderSet(true))
    dispatch(nullUserDetails())
    navigate("/")
    setTimeout(() => {
      dispatch(loaderSet(false))
    }, 3000);

  }

  const handleNavigateToProfile = () => {
    dispatch(loaderSet(true))
    navigate("/distributor/profile")
    setTimeout(() => {
      // dispatch(nullUserDetails())
      dispatch(loaderSet(false))
    }, 3000);

  }

  const [filteredInvestorDataForDistributor, setFilteredInvestorDataForDistributor] = useState([])

  useEffect(() => {
    console.log(searchTerm)
    if (searchTerm.length > 0) {
      setFilteredInvestorDataForDistributor(investorDetailsForTable.filter((investor) => {
        const search = searchTerm.toLowerCase();
        return (
          investor.user_email.toLowerCase().includes(search) ||
          investor.name.toLowerCase().includes(search) ||
          investor.mobile_number.toString().toLowerCase().includes(search)

        );
      }))
    }
    else {
      setFilteredInvestorDataForDistributor(investorDetailsForTable)
    }

  }, [searchTerm, investorDetailsForTable])



  return (
    <TooltipProvider>
      <div className="flex min-h-screen w-full flex-col bg-muted/40">
        <aside className={`fixed inset-y-0 left-0 z-10 flex flex-col transition-all duration-300 ease-in-out ${collapsed ? "w-14" : "w-60"} bg-background`}>
          {/* accessiblity fix for silktide issues - semantic navigation list */}
          <nav className="flex flex-col items-center px-2 py-5" aria-label="Primary navigation">
            <ul className="flex flex-col items-center gap-4 w-full">
              {navigation.map((item, index) => (
                <li key={index} className="w-full list-none">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <button
                        type="button"
                        onClick={() => handleTabClick(item.name)} // Handle tab click
                        aria-label={`${item.name} navigation item`}
                        aria-current={item.current ? "page" : undefined}
                        className={`flex items-center gap-4 px-2.5 h-9 w-full rounded-lg transition-colors hover:text-foreground focus-visible:ring-2 focus-visible:ring-[#0D215C] focus-visible:ring-offset-2 ${item.current ? "bg-accent text-[#0D215C]" : "text-black"
                          }`}
                      >
                        <span className={`flex items-center ${collapsed ? "w-full justify-center" : "w-auto justify-start"}`}>
                          <img src={item.current ? item.icon2 : item.icon} alt="" aria-hidden="true" className={` w-5 font-bold `} />
                        </span>
                        {!collapsed && <span className="ml-2">{item.name}</span>}
                      </button>
                    </TooltipTrigger>
                    {collapsed && <TooltipContent side="right">{item.name}</TooltipContent>}
                  </Tooltip>
                </li>
              ))}
            </ul>
          </nav>
          <button type="button" className="mt-auto mb-4 p-5 text-black w-full" onClick={handleToggle} aria-expanded={!collapsed} aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}>
            <PanelLeft className="h-5 w-5" />
          </button>
        </aside>

        <div className={`flex-1 flex flex-col transition-all duration-300 ease-in-out ${collapsed ? "ml-14" : "ml-60"}`}>
          <header className="sticky w-full justify-between items-center top-0 z-30 flex h-14 gap-4 border-b bg-background px-4">
            <Breadcrumb className="hidden md:flex pl-5 ">
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/distributor">Distributor</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />

                <>
                  <BreadcrumbItem>{location.pathname === "/distributor/profile" ? "Profile" : selectedTab}</BreadcrumbItem>
                </>

              </BreadcrumbList>
            </Breadcrumb>

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button type="button" variant="outline" size="icon" aria-label="Open user menu" className="overflow-hidden rounded-full flex items-center">
                  <img src={userInfo && userInfo.image_url ? userInfo.image_url : "./avatar.png"} width={36} height={36} alt="Avatar" className="overflow-hidden rounded-full" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem><button onClick={() => { handleNavigateToProfile() }} >Profile</button></DropdownMenuItem>
                <DropdownMenuItem> <button onClick={() => { handleLogout() }} >Logout</button  >  </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </header>

          <main className="flex-1 h-screen overflow-y-auto p-4">
            {/* accessiblity fix for silktide issues - H1 heading */}
            <h1 className="sr-only">{location.pathname === "/distributor/profile" ? "Profile" : selectedTab}</h1>
            {/* Conditionally render components based on selected tab */}
            {/* {selectedTab === "Dashboard" && <Dashboard />} */}
            {location.pathname === "/distributor/profile" ? <Profile />
              :
              !investorInfoComponent ?
                selectedTab === "Investor" &&
                <>
                  <div className="w-full flex justify-between items-start p-2 bg-[#FFFFFF] rounded-md">
                    <div className="flex w-full justify-end items-center gap-4">
                      {/* Search Bar */}
                      <div className="flex w-96 gap-2 border-b-2 border-[#0D215C]">
                        <label htmlFor={searchInputId} className="sr-only">Search investors</label>
                        <Search className="h-8 w-6 text-muted-foreground pointer-events-none" aria-hidden="true" focusable="false" />
                        {/* accessiblity fix for silktide issues */}
                        <Input
                          id={searchInputId}
                          type="search"
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          aria-label="Search investors"

                          className="rounded-md border border-[#0D215C] bg-white text-black focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D215C] focus-visible:ring-offset-1 text-lg"
                        />
                      </div>

                      {/* Dropdown Menu */}
                      {/* <div className="flex items-center gap-2">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="outline" size="sm" className="h-7 gap-1 text-sm">
                      <ListFilter className="h-3.5 w-3.5" />
                      <span className="sr-only sm:not-sr-only">Filter</span>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuLabel>Filter by</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <DropdownMenuCheckboxItem checked>Fulfilled</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem>Declined</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem>Refunded</DropdownMenuCheckboxItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div> */}
                    </div>
                  </div>


                  <div className="w-full bg-[#FFFFFF] mt-4 rounded-md " >
                    {/* <DataTable2 onRowClick={handleInvestorInfoId} />  */}
                    <Datatable3 totalPage={totalPage} currentPage={currentPage} setCurrentPage={setCurrentPage} columns={columns} user_type={"investor"} data={filteredInvestorDataForDistributor} onRowClick={handleInvestorInfoId} />
                  </div>
                </>
                : <InvestorInfo back={() => setInvestorInfoComponent(false)} />}
          </main>
        </div>
      </div>

    </TooltipProvider>
  );
}
